import { Box, Grid, Typography } from '@mui/material';
import AddressFields from '@features/workspace/components/users/components/address-fields';
import { FC } from 'react';

const CustomerProfileEditBusinessAddress: FC<any> = ({
  data,
  register,
  errors,
  control,
}) => {
  return (
    <Box display="flex" flexDirection="column" flexGrow={1}>
      <Box display="flex">
        <Typography variant="legend">Business address</Typography>
      </Box>
      <Box display="flex" mt={2}>
        <Grid container spacing={9}>
          {/* Left side */}
          <Grid item md={6}>
            <AddressFields
              control={control}
              data={data}
              errors={errors}
              register={register}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default CustomerProfileEditBusinessAddress;
